import { parse } from "@babel/core";
import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { SingleTransaction, TransactionParser } from "../transactionList-viewModel";
import  { TransactionDetailView } from "./transactionDetail-view"

export class TransactionDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new TransactionDetailView();
    }
    public getTypeId(): string {
        return "VM-01102BA2-0205-456A-933F-072C3297C115"
    }
    closePopup(resultCode: string=null) {}

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set transaction(v: SingleTransaction) { this._transaction = v; } public get transaction(): SingleTransaction { return this._transaction;} private _transaction: SingleTransaction;
    

    async loadById(id:string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/AccountingServices/LoadTransaction",{
                Id:id
            });
            var parser = new TransactionParser();   
            let transaction = parser.parseSingle(result.Transaction,this);
            this.loadByVm(transaction);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    loadByVm(transaction:SingleTransaction){
        this.transaction = transaction;
    }
}
